export enum WorkflowTaskDetailType {
  CHANGE_TICKET_STATUS = 'change_ticket_status',
  CREATE_TICKET = 'create_ticket',
  DB_DOWNLOAD = 'db_download',
  DELAY = 'delay',
  FTP_DOWNLOAD = 'ftp_download',
  IMPORT_CUSTOMER = 'import_customer',
  SEND_EMAIL = 'send_email',
  SEND_EMAIL_NOTIFICATION = 'send_email_notification',
  SEND_SMS = 'send_sms',
  SEND_WHATSAPP = 'send_whatsapp',
  SEND_PUSH_NOTIFICATION = 'send_push_notification',
  CREATE_CATI_CALL = 'create_cati_call',
  WEBHOOK = 'webhook',
  PISANO_DOWNLOAD = 'pisano_download',
  ANONYMIZATION = 'anonymization',
  ADVANCED_TEXT_ANALYSIS = 'advanced_text_analysis',
  MIGRATION = 'migration',
  STORAGE_DOWNLOAD = 'storage_download',
  DISTRIBUTION_STATISTIC = 'distribution_statistic',
  STORAGE_UPLOAD = 'storage_upload',
  IMPORT_FEEDBACK = 'import_feedback',
  PUSH_REPORT_METRIC = 'push_report_metric',
  SCHEDULE_REPORTS = 'send_digest',
  EXPORT_ACTION_LOG = 'export_action_log',
  EMAIL_SEND = 'email_send',
  TRANSFORM = 'transform',
  FEEDBACK_EXPORT = 'feedback_export',
  TAG = 'tag',
  PUSH_TICKET_TO_QUEUE = 'push_ticket_to_queue',
  BUILD_TARGET_AUDIENCE = 'build_target_audience',
  BRANCH_IF = 'branch_if',
  BRANCH_ELSE = 'branch_else',
  BRANCH_END = 'branch_end',
  NPS_TAG = 'nps_tag',
}
